module.exports = __webpack_public_path__ + "static/media/ship_red_flip.def6bbaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ship_red_flip.png
// module id = 208
// module chunks = 0